<template>
  <section>
    <div class="box">
      <div class="level item-information-column-direction">
        <div class="level-item has-text-centered" style="justify-content: space-between">
          <div style="display: flex; justify-content: space-around; width: 40%">
            <div class="margin-2">
              <p class="heading">LOTE</p>
              <p>
                <strong>{{ item.identificador }}</strong>
              </p>
            </div>
            <div class="margin-2">
              <p class="heading">Descrição</p>
              <p class="description-text" ref="description-text">
                <strong>{{ item.item.descricao }}</strong>
              </p>
            </div>
          </div>
          <div class="margin-2">
            <p class="heading">{{ columnName }}</p>
            <p class="description-text" ref="description-text">
              <strong>{{ totalFormatado }}</strong>
            </p>
          </div>

          <div class="margin-2">
            <button class="button is-primary item-information-back-button" @click="handleVoltar">
              Voltar
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-loading :active="loading" is-full-page>
      <b-icon pack="fas" icon="sync-alt" size="is-large" custom-class="fa-spin" />
    </b-loading>

    <b-table v-if="!loading" :data="batchItens" class="table is-fullwidth" hoverable>
      <b-table-column label="ID" v-slot="props">
        {{ props.row.identificador }}
      </b-table-column>

      <b-table-column label="Descrição" width="650" v-slot="props">
        {{ props.row.descricao }}
      </b-table-column>

      <b-table-column label="Unidade" v-slot="props">
        {{ props.row.unidade }}
      </b-table-column>

      <b-table-column label="Quantidade" v-slot="props">
        {{ formatarNumero(props.row.quantidade || 0) }}
      </b-table-column>

      <b-table-column v-if="maiorDesconto" :label="getValorColumnName" v-slot="props">
        <b-field
          :type="campoInvalidoDinamic('percentual', props.row.id) ? 'is-danger' : ''"
          :message="campoInvalidoDinamic('percentual', props.row.id) ? 'Percentual inválido' : ''"
        >
          <AppPorcentagem
            permitir-percentual-zero
            :item="props.row"
            :valores="dados[props.row.id]"
            :valor-percentual="dados[props.row.id].percentual || 0"
            :width="'110'"
            :carregar-percentual="carregarDados"
            :desabilitar-campos="estaDesabilitado(props.row.id)"
            :percentual-valido="percentualValido(dados[props.row.id].percentual)"
            @valor="val => updatePercentual(props.row.id, val)"
          />
        </b-field>
      </b-table-column>

      <b-table-column v-else :label="getValorColumnName" v-slot="props">
        <b-field
          :type="campoInvalidoDinamic('valorUnitario', props.row.id) ? 'is-danger' : ''"
          :message="campoInvalidoDinamic('valorUnitario', props.row.id) ? 'Valor inválido' : ''"
        >
          <AppValor
            :item="props.row"
            :valores="dados[props.row.id]"
            :valor-monetario="dados[props.row.id].valorUnitario || 0"
            :width="'160'"
            :exibir-input="true"
            :placeholder="'Valor unitário'"
            :carregar-valor="carregarDados"
            :desabilitar-campos="estaDesabilitado(props.row.id)"
            :valor-valido="valorUnitarioValido(dados[props.row.id].valorUnitario)"
            @blur="$v.dados[props.row.id].valorUnitario.$touch()"
            @valor="val => updateValor(props.row.id, val)"
          />
        </b-field>
      </b-table-column>

      <b-table-column v-if="maiorDesconto" label="Valor Unitário (R$)" v-slot="props">
        {{ formatarValor(dados[props.row.id].valorUnitario || 0) }}
      </b-table-column>

      <b-table-column label="Valor Total (R$)" v-slot="props">
        {{ formatarValor(dados[props.row.id].valorTotal || 0) }}
      </b-table-column>

      <b-table-column label="Marca/Modelo" v-slot="props">
        <b-field
          :type="campoInvalidoDinamic('marca', props.row.id) ? 'is-danger' : ''"
          :message="campoInvalidoDinamic('marca', props.row.id) ? 'Campo obrigatório' : ''"
        >
          <b-input
            :placeholder="'Marca/Modelo'"
            :class="{ 'is-danger': campoInvalidoDinamic('marca', props.row.id) }"
            :disabled="estaDesabilitado(props.row.id)"
            v-model="dados[props.row.id].marca"
            @blur="
              evento => converterMaiusculo('marca', evento.target.value, `dados.${props.row.id}`)
            "
          />
        </b-field>
      </b-table-column>

      <b-table-column :expanded="tablet" label="Fabricado" v-slot="props">
        <b-field class="is-flex is-align-items-center">
          <b-radio-button
            v-model="dados[props.row.id].fabricado"
            native-value="BRASIL"
            :disabled="estaDesabilitado(props.row.id)"
          >
            Brasil
          </b-radio-button>
          <b-radio-button
            v-model="dados[props.row.id].fabricado"
            native-value="IMPORTADO"
            :disabled="estaDesabilitado(props.row.id)"
          >
            Importado
          </b-radio-button>
        </b-field>

        <p class="help is-danger" v-if="campoInvalidoDinamic('fabricado', props.row.id)">
          Selecione uma opção
        </p>
      </b-table-column>

      <b-table-column v-if="!canSend" label="Ações" v-slot="props">
        <button
          class="button is-primary options-button"
          :disabled="modoEdicao[props.row.id]"
          @click="$set(modoEdicao, props.row.id, true)"
        >
          <b-icon icon="pencil" size="is-small" />
        </button>
      </b-table-column>
    </b-table>

    <div
      class="has-text-right mt-4"
      style="display: flex; justify-content: end; align-items: center"
    >
      <div class="has-text-weight-bold" style="margin-right: 4vh">
        Proposta: {{ totalFormatado }}
      </div>
      <b-tooltip position="is-left" :active="showBillingWarning" type="is-danger">
        <template #content>
          <span>{{ billingTooltipMessage }}</span>
        </template>
        <button
          class="button is-primary send-proposal-button"
          style="height: 100%"
          @click.stop.prevent="informarPIN"
          :disabled="showBillingWarning || !canSend || enviandoProposta"
        >
          {{ enviandoProposta ? 'Aguarde...' : textoBotaoEnviar }}
        </button>
      </b-tooltip>
    </div>
    <b-modal :active.sync="validandoPIN" :onCancel="resetarEstado" has-modal-card>
      <pin-form v-if="validandoPIN" :reason="reasonPIN" @validar="enviarProposta" />
    </b-modal>

    <b-modal has-modal-card :active.sync="declarationsModal" :onCancel="cancelDeclarations">
      <DeclarationsModal
        v-if="declarationsModal"
        :showPreference="showPreferenceDeclarations"
        :companySize="company.companySize"
        @confirm="handleDeclarationsConfirm"
        @cancel="cancelDeclarations"
      />
    </b-modal>
  </section>
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import { mapState, mapGetters, mapActions } from 'vuex';
import AppValor from '@/components/AppValor';
import AppPorcentagem from '@/components/AppPorcentagem';
import BILLING_MESSAGES from '@/constants/billingMessages';
import formulario from '@/mixins/formulario';
import { formatarNumero, formatarValor } from '@/utils/format';
import {
  reconcileLotAmounts,
  resolveUnitInput,
  totalFromUnit,
  unitFromDiscount,
} from '@/utils/proposalAmounts';
import PinForm from '@/views/User/Pin';
import DeclarationsModal from '@/views/Pregao/AuctionContainer/Proposals/DeclarationsModal';

export default {
  name: 'BatchProposalSender',
  components: { AppValor, AppPorcentagem, PinForm, DeclarationsModal },
  mixins: [formulario],
  props: {
    item: Object,
    proposals: Array,
  },
  data() {
    return {
      loading: true,
      batchItens: [],
      dados: {},
      modoEdicao: {},
      validandoPIN: false,
      carregarDados: false,
      enviandoProposta: false,
      reasonPIN: 'PREGAO-CRIAR-PROPOSTA',
      declarationsModal: false,
      pendingSendProposal: false,
    };
  },
  validations() {
    const rules = { dados: {} };
    this.batchItens.forEach(item => {
      rules.dados[item.id] = {
        marca: { required },
        fabricado: { required },
      };
      if (this.maiorDesconto) {
        rules.dados[item.id].percentual = {
          required,
          minValue: minValue(0),
          maxValue: maxValue(99.9999),
        };
      } else {
        rules.dados[item.id].valorUnitario = {
          required,
          minValue: minValue(0.0001),
        };
      }
    });
    return rules;
  },
  watch: {
    batchItens: {
      immediate: true,
      handler(novas) {
        const data = {};
        novas.forEach(item => {
          this.$set(this.modoEdicao, item.id, false);
          data[item.id] = this.montarLinha(item);
        });
        this.dados = data;
      },
    },
  },
  methods: {
    ...mapActions('proposals', ['fetchBatchItemProposals', 'createProposal', 'updateProposal']),
    ...mapActions(['buscarItensLote', 'clearBatchItens']),
    ...mapActions('companyBilling', ['getCompanyCredits', 'getCompanyCurrentBillingMethod']),
    ...mapActions('auctionsDeclarations', ['createAuctionDeclaration', 'removeAuctionDeclaration']),
    formatarNumero,
    formatarValor,
    handleVoltar() {
      this.clearBatchItens();
      this.$emit('voltar');
    },
    montarLinha(item) {
      const propostaExistente =
        this.batchItemProposals.find(p => p.ofertaCompraLoteItemId === item.id) || {};
      const percentual =
        propostaExistente.percentual != null ? Number(propostaExistente.percentual) : null;
      let valorUnitario = resolveUnitInput(propostaExistente, this.tipoNegociacao);
      if (
        valorUnitario == null &&
        this.maiorDesconto &&
        percentual != null &&
        Number(item.referencia) > 0
      ) {
        valorUnitario = unitFromDiscount(item.referencia, percentual);
      }

      return {
        valorUnitario,
        percentual,
        valorTotal: valorUnitario != null ? totalFromUnit(valorUnitario, item.quantidade) : null,
        marca: propostaExistente.marca ?? '',
        fabricado: propostaExistente.fabricado ?? '',
        propostaId: propostaExistente.id ?? null,
      };
    },
    campoInvalidoDinamic(campo, id) {
      try {
        return this.$v.dados[id][campo].$invalid && this.$v.dados[id][campo].$dirty;
      } catch {
        return false;
      }
    },
    valorUnitarioValido(valor) {
      return Number(valor) > 0;
    },
    percentualValido(valor) {
      const percentual = Number(valor);
      return Number.isFinite(percentual) && percentual >= 0 && percentual < 100;
    },
    updateValor(id, val) {
      const item = this.batchItens.find(loteItem => loteItem.id === id);
      this.dados[id].valorUnitario = val.valor;
      this.dados[id].valorTotal = totalFromUnit(val.valor, item ? item.quantidade : 0);
    },
    updatePercentual(id, val) {
      const item = this.batchItens.find(loteItem => loteItem.id === id);
      this.dados[id].percentual = val.percentual;
      if (item && Number(item.referencia) > 0) {
        this.dados[id].valorUnitario = unitFromDiscount(item.referencia, val.percentual);
        this.dados[id].valorTotal = totalFromUnit(this.dados[id].valorUnitario, item.quantidade);
      } else {
        this.dados[id].valorUnitario = null;
        this.dados[id].valorTotal = null;
      }
    },
    montarPayloadItem(item) {
      const dadosItem = this.dados[item.id];
      const payload = {
        propostaId: dadosItem.propostaId,
        ofertaCompraItemId: item.ofertaCompraItemId,
        ofertaCompraLoteItemId: item.id,
        empresaId: this.company.id,
        marca: dadosItem.marca,
        fabricado: dadosItem.fabricado,
      };

      if (this.maiorDesconto) {
        payload.percentual = dadosItem.percentual;
      } else {
        payload.valorUnitario = dadosItem.valorUnitario;
      }

      return payload;
    },
    async enviarProposta() {
      this.enviandoProposta = true;
      if (!this.validar('dados')) {
        this.enviandoProposta = false;
        return;
      }
      if (!this.pinValido) {
        this.enviandoProposta = false;
        return;
      }
      try {
        const payload = this.batchItens.map(item => this.montarPayloadItem(item));

        if (this.existePropostaCriada) {
          try {
            await this.updateProposal(payload);
            this.$alerta('Proposta atualizada', 'is-success');
          } catch (error) {
            const resposta = error.response?.data || {};
            if (resposta.error?.type === 'ForaDoPrazo') {
              this.$alerta('Fora do prazo', 'is-danger');
            } else {
              this.$alerta('Erro ao atualizar proposta', 'is-danger');
            }
          }
        } else {
          try {
            await this.createProposal(payload);
            this.$alerta('Proposta enviada', 'is-success');
          } catch (error) {
            const resposta = error.response?.data || {};
            if (resposta.error?.type === 'ForaDoPrazo') {
              this.$alerta('Fora do prazo', 'is-danger');
            } else {
              this.$alerta('Erro ao enviar proposta', 'is-danger');
            }
          }
        }
        await this.getCompanyCredits(this.company.id);
      } finally {
        this.validandoPIN = false;
        this.enviandoProposta = false;
        this.handleVoltar();
      }
    },
    existeReferencial(item) {
      return Number(item.total) > 0 || Number(item.referencia) > 0;
    },
    informarPIN() {
      // Verifica se já tem declarações aceitas
      const requirements = this.auctionDeclarations.some(
        element => element.declaration === 'REQUISITOS',
      );

      if (!requirements) {
        // Se não tem declarações, abre o modal
        this.pendingSendProposal = true;
        this.declarationsModal = true;
        return;
      }

      // Se já tem declarações, continua com o fluxo normal
      if (!this.pinValido) {
        this.validandoPIN = true;
      } else {
        this.enviarProposta();
      }
    },
    async createDeclaration(declarationType, declarationValue) {
      try {
        if (declarationValue) {
          await this.createAuctionDeclaration({
            auctionId: this.ofertaCompra.id,
            companyId: this.company.id,
            type: declarationType,
            value: declarationValue,
          });
        } else {
          const declaration = this.auctionDeclarations.find(
            element => element.declaration === declarationType,
          );

          if (declaration) {
            await this.removeAuctionDeclaration({
              auctionId: this.ofertaCompra.id,
              companyId: this.company.id,
              declarationId: declaration.id,
            });
          }
        }
      } catch (error) {
        if (error && error.response) {
          const { data } = error.response;
          if (data.error === 'ValidationError' && data.details.message === 'Fora do prazo') {
            this.$alerta(data.details.message, 'is-danger');
            return;
          }
        }

        this.$alerta(
          declarationValue ? 'Erro ao aceitar declaração' : 'Erro ao remover declaração',
          'is-danger',
        );
      }
    },
    async handleDeclarationsConfirm(payload = {}) {
      await this.createDeclaration('requirements', true);

      if (payload.regionalPreference === true) {
        await this.createDeclaration('regionalPreference', true);
      }

      this.declarationsModal = false;

      if (this.pendingSendProposal) {
        this.pendingSendProposal = false;
        if (!this.pinValido) {
          this.validandoPIN = true;
        } else {
          this.enviarProposta();
        }
      }
    },
    cancelDeclarations() {
      this.declarationsModal = false;
      this.pendingSendProposal = false;
    },
    carregarPropostasExistentes() {
      const data = {};
      this.batchItens.forEach(item => {
        this.modoEdicao[item.id] = false;
        data[item.id] = this.montarLinha(item);
      });
      this.dados = data;
      this.carregarDados = true;
    },
    resetarEstado() {
      this.validandoPIN = false;
    },
    estaDesabilitado(id) {
      return (
        this.isSineDieFromEntregaDePropostas ||
        (this.dados[id].propostaId && !this.modoEdicao[id]) ||
        this.showBillingWarning
      );
    },
  },
  computed: {
    ...mapGetters({
      logged: 'getLogged',
    }),
    ...mapGetters('app', { tablet: 'tablet' }),
    ...mapGetters('auctionsDeclarations', {
      auctionDeclarations: 'getDeclarations',
      auctionDeclarationsLoaded: 'getDeclarationsLoaded',
    }),
    ...mapState('proposals', ['batchItemProposals']),
    ...mapState('companies', ['company']),
    ...mapState('companyBilling', ['status', 'currentBillingMethodId', 'companyCredits']),
    ...mapGetters('companyBilling', ['hasBillingWarning']),
    ...mapGetters({
      ofertaCompra: 'obterOfertaCompra',
      pinValido: 'getValidPin',
      isSineDieFromEntregaDePropostas: 'isSineDieFromEntregaDePropostas',
    }),
    tipoNegociacao() {
      return this.ofertaCompra.tipo_negociacao.id;
    },
    maiorDesconto() {
      return this.tipoNegociacao === 3;
    },
    columnName() {
      return 'VALOR PROPOSTA';
    },
    getValorColumnName() {
      if (this.maiorDesconto) return 'Percentual (%)';

      return 'Valor Unitário (R$)';
    },
    totalFormatado() {
      return Number(this.totalCalculado).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });
    },
    totalCalculado() {
      if (!this.batchItens.length || !this.dados) return 0;
      const itens = this.batchItens
        .map(item => {
          const linha = this.dados[item.id];
          if (!linha || linha.valorUnitario == null) return null;
          return {
            quantidade: item.quantidade,
            valorUnitario: linha.valorUnitario,
          };
        })
        .filter(Boolean);

      if (!itens.length) return 0;
      return reconcileLotAmounts(itens).valorTotal;
    },
    textoBotaoEnviar() {
      return this.existePropostaCriada ? 'Atualizar Propostas' : 'Enviar Propostas';
    },
    existePropostaCriada() {
      return this.batchItens.some(item => this.dados[item.id] && this.dados[item.id].propostaId);
    },

    divulgarReferencial() {
      return !!Number(this.ofertaCompra && this.ofertaCompra.divulgar_referencial);
    },
    canSend() {
      if (!this.existePropostaCriada) {
        return true;
      }
      return Object.values(this.modoEdicao).some(v => v === true);
    },
    requirementsDeclaration() {
      return this.auctionDeclarations.some(element => element.declaration === 'REQUISITOS');
    },
    showPreferenceDeclarations() {
      return (
        this.company.preference &&
        this.ofertaCompra.tipo_edital === 'RESERVADO' &&
        this.ofertaCompra.preferencia_regional
      );
    },
    showBillingWarning() {
      return this.hasBillingWarning && this.proposals.length === 0;
    },
    billingTooltipMessage() {
      return BILLING_MESSAGES.TOOLTIP_WARNING;
    },
    getTotalProposal() {
      const found = this.proposals.find(p => p.oferta_compra_item_id === this.item.id);
      return found ? found.valor : null;
    },
  },
  async mounted() {
    try {
      const loteId = this.item.id;

      const resultado = await this.buscarItensLote({ itemId: loteId });
      this.batchItens = resultado || [];

      await this.fetchBatchItemProposals({
        auctionId: this.ofertaCompra.id,
        auctionItemId: this.item.id,
      });
      this.carregarPropostasExistentes();

      await this.getCompanyCredits(this.company.id);
      await this.getCompanyCurrentBillingMethod(this.company.id);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .send-proposal-button {
    margin-top: 0.5rem;
  }
}

.info-item {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.9rem;
}
</style>
